import { Link } from 'react-router-dom';

export function Footer() {
  return (
    <footer className="bg-[#0b2217] text-ivory">
      <div className="container-page py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-[1.5fr_1fr_1fr_1fr_1fr]">
          {/* Logo & Subtext */}
          <div className="flex flex-col items-start">
            <Link to="/" className="flex items-center gap-2">
              <svg className="h-7 w-7 text-ivory" viewBox="0 0 24 24" fill="currentColor">
                <path d="M17 8C8 10 59 16.5 17 8zM12 2C6.48 2 2 6.48 2 12c0 3.6 1.9 6.76 4.75 8.53C6.46 19.34 6 17.72 6 16c0-4.42 3.58-8 8-8 1.72 0 3.34.46 4.53 1.25C20.3 7.9 17.14 6 13.5 6 9.36 6 6 9.36 6 13.5c0 .35.03.7.08 1.04C4.84 13.12 4 11.16 4 9c0-4.41 3.59-8 8-8s8 3.59 8 8c0 .34-.02.68-.06 1.01C20.58 9.36 21 10.63 21 12c0 4.97-4.03 9-9 9s-9-4.03-9-9c0-.68.08-1.34.22-1.97" />
              </svg>
              <div className="flex flex-col">
                <span className="font-heading text-2xl font-normal leading-none tracking-tight text-ivory">
                  Orényva
                </span>
                <span className="mt-0.5 text-[8px] font-semibold tracking-widest text-ivory/70 uppercase">
                  NATURAL ORAL CARE
                </span>
              </div>
            </Link>
            <p className="mt-5 text-xs italic text-ivory/70">Good Habits, A Brighter Tomorrow</p>
          </div>

          {/* Column 1: SHOP */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-ivory/90">SHOP</h4>
            <ul className="mt-4 flex flex-col gap-2.5 text-xs text-ivory/70">
              <li>
                <Link to="/shop" className="hover:text-ivory">
                  Shop Toothbrushes
                </Link>
              </li>
              <li>
                <Link to="/shop" className="hover:text-ivory">
                  Travel Tubes
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 2: ABOUT */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-ivory/90">ABOUT</h4>
            <ul className="mt-4 flex flex-col gap-2.5 text-xs text-ivory/70">
              <li>
                <Link to="/about" className="hover:text-ivory">
                  Our Story
                </Link>
              </li>
              <li>
                <Link to="/why-orenyva" className="hover:text-ivory">
                  Why Orenyva
                </Link>
              </li>
              <li>
                <Link to="/reviews" className="hover:text-ivory">
                  Reviews
                </Link>
              </li>
              <li>
                <Link to="/faq" className="hover:text-ivory">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-ivory">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3: HELP */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-ivory/90">HELP</h4>
            <ul className="mt-4 flex flex-col gap-2.5 text-xs text-ivory/70">
              <li>
                <Link to="/shipping-policy" className="hover:text-ivory">
                  Shipping
                </Link>
              </li>
              <li>
                <Link to="/refund-policy" className="hover:text-ivory">
                  Returns
                </Link>
              </li>
              <li>
                <Link to="/privacy-policy" className="hover:text-ivory">
                  Privacy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="hover:text-ivory">
                  Terms
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 4: FOLLOW */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-ivory/90">FOLLOW</h4>
            <div className="mt-4 flex items-center gap-3 text-ivory/80">
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram"
                className="hover:text-ivory"
              >
                <svg className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
                  <rect x="2" y="2" width="20" height="20" rx="5" />
                  <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                  <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
                </svg>
              </a>
              <a
                href="https://tiktok.com"
                target="_blank"
                rel="noreferrer"
                aria-label="TikTok"
                className="hover:text-ivory"
              >
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M19.589 6.686a4.793 4.793 0 0 1-3.77-4.245V2h-3.445v13.672a2.896 2.896 0 0 1-5.201 1.743l-.002-.001.002.001a2.895 2.895 0 0 1 3.183-4.51v-3.5a6.329 6.329 0 0 0-5.394 2.174 6.33 6.33 0 0 0 1.954 9.176 6.331 6.331 0 0 0 8.903-5.263V9.12a8.232 8.232 0 0 0 3.77 1.011V6.686z" />
                </svg>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-ivory/15 pt-6 text-[11px] text-ivory/50 md:flex-row">
          <p>&copy; 2025 Orenyva. All rights reserved.</p>
          <div className="flex items-center gap-3">
            <span className="rounded bg-white/10 px-2 py-1 text-[10px] font-bold text-ivory">VISA</span>
            <span className="rounded bg-white/10 px-2 py-1 text-[10px] font-bold text-ivory">MASTERCARD</span>
            <span className="rounded bg-white/10 px-2 py-1 text-[10px] font-bold text-ivory">AMEX</span>
            <span className="rounded bg-white/10 px-2 py-1 text-[10px] font-bold text-ivory">PAYPAL</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
